import React from 'react';
import {
  SegmentProvider as SharedSegmentProvider,
  type SegmentProviderProps,
  useSegment,
} from '@hellodarwin/app-core/lib/providers/segment-provider';

export const DEFAULT_CLIENT_APP_SEGMENT_WRITE_KEY =
  'mdkntFTs2kgcdXdQstiDz15EY3kQDPbY';

export type ClientSegmentProviderProps = Omit<
  SegmentProviderProps,
  'initialPageProperties' | 'trackInitialPage'
>;
export { useSegment };

export const SegmentProvider: React.FC<ClientSegmentProviderProps> = ({
  writeKey = DEFAULT_CLIENT_APP_SEGMENT_WRITE_KEY,
  ...props
}) => (
  <SharedSegmentProvider
    {...props}
    writeKey={writeKey}
    trackInitialPage={false}
  />
);

export default SegmentProvider;
